<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <div class="form-group">
                <form v-on:submit.prevent="$emit('saveChanges')">
                    <label :for="name+'-name'">Naam</label>
                    <input v-validate="'required'"
                           :name="name+'-name'"
                           :id="name+'-name'"
                           type="text"
                           class="form-control"
                           v-model="value.name">
                </form>
            </div>
            <div v-if="showStandard" class="form-group">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :id="name+'-standard'" checked=""
                           v-model="value.standard">
                    <label class="custom-control-label" :for="name+'-standard'">
                        Standaard
                    </label>
                </div>
            </div>
        </template>

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                Annuleren
            </button>
            <button type="button" class="btn btn-primary" :disabled="!value.name.length" @click="saveChanges" data-dismiss="modal">
                <i class="fal fa-save mr-2"></i> Opslaan
            </button>

        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            index: {},
            title: {},
            value: {},
            name: {},
            showStandard: {type: Boolean, default: true},
        },
        methods: {
            saveChanges() {
                this.$emit('saveChanges', this.value);
            }
        },
    }
</script>